import { render, staticRenderFns } from "./AddLiveAccountModal.vue?vue&type=template&id=33a734ff"
import script from "./AddLiveAccountModal.vue?vue&type=script&lang=js"
export * from "./AddLiveAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports